export default "__VITE_ASSET__nyiV0LAr__"